<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-breadcrumb
                [title]="'Suivi des opérations'"
                [active_item]="'Centre de Notifications'"
            ></app-breadcrumb>
            <div class="card">
                <div class="card-body">
                    <div [hidden]="!initialView">
                        <div class="table_content_wrapper">
                            <div class="table_header">
                                <div>
                                    <app-table-title
                                        [label]="false"
                                        [count]="totalRecords"
                                        [perPage]="recordsPerPage"
                                        [page]="page"
                                        [totalPage]="totalPage"
                                    >
                                    </app-table-title>
                                </div>
                                <div>
                                    <button
                                        pButton
                                        pRipple
                                        label="Effacer"
                                        class="p-button-warning mt-2"
                                        [disabled]="
                                            checkconsumerList?.length === 0
                                        "
                                        (click)="OnReadNotification()"
                                    ></button>
                                </div>
                            </div>
                            <table [ngClass]="['native_table table']">
                                <thead>
                                    <th class="text-center">#</th>
                                    <th>Date/heure</th>
                                    <th class="text-center">Reference</th>
                                    <th class="text-center">
                                        Type Notification
                                    </th>
                                    <th class="text-center">Description</th>
                                    <th class="text-center">
                                        <p-checkbox
                                            [binary]="true"
                                            (click)="OnCheckAllConsumer()"
                                            [(ngModel)]="checkedAllConsumers"
                                        ></p-checkbox>
                                    </th>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let data of listNotifys
                                                | paginate
                                                    : {
                                                          itemsPerPage:
                                                              recordsPerPage,
                                                          currentPage: p,
                                                          totalPages: totalPage,
                                                          totalItems:
                                                              totalRecords
                                                      };
                                            let i = index
                                        "
                                    >
                                        <td class="text-center">
                                            {{ this.offset + i }}
                                        </td>
                                        <td>{{ data?.created_at }}</td>
                                        <td class="text-center">
                                            {{ data?.reference }}
                                        </td>
                                        <td class="text-center">
                                            {{ data?.operation }}
                                        </td>
                                        <td
                                            [innerHTML]="data?.description"
                                        ></td>
                                        <td>
                                            <p-checkbox
                                                name="groupname"
                                                [value]="data.id"
                                                [binary]="true"
                                                [(ngModel)]="data.checked"
                                                (click)="
                                                    onCheckedOneConsumer(data)
                                                "
                                            ></p-checkbox>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div [ngClass]="['pagination-controls']">
                                <pagination-controls
                                    (pageChange)="onPageChange($event)"
                                    previousLabel=""
                                    nextLabel=""
                                >
                                </pagination-controls>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="showView">
                        <app-show-notification
                            [currentData]="currentData"
                            [selectedOperation]="currentOperation"
                            (showView)="pushStatutView($event)"
                        ></app-show-notification>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
